import { render, staticRenderFns } from "./ProtocolloUtentiEdit.vue?vue&type=template&id=3d1b02c1"
import script from "./ProtocolloUtentiEdit.vue?vue&type=script&lang=js"
export * from "./ProtocolloUtentiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports